import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import Select from 'common/components/form/inputs/Select';

import { useActions } from 'utils/hooks';
import * as listActions from 'store/lists/actions';

const JobLogTypesSelector = ({ filter, value, onChange, label, placeholder }) => {
  const [fetchListOptions] = useActions([listActions.fetchListOptions]);
  const jobLogStatuses = useSelector(state => state.lists['job-log-statuses']);

  useEffect(() => {
    if (!jobLogStatuses.options.length) fetchListOptions('job-log-statuses');
  }, []);

  return (
    <Select
      label={label}
      placeholder={placeholder ? placeholder : 'Select value'}
      getOptionValue={option => option.status}
      getOptionLabel={option => option.status}
      value={filter ? (filter.value && Array.isArray(filter.value) ? filter.value : []) : value}
      options={jobLogStatuses.options}
      isMulti={true}
      onChange={selected =>
        onChange({
          data: selected ? selected : [],
          value: selected ? selected : ''
        })
      }
      isClearable
    />
  );
};

export default JobLogTypesSelector;
